export const limitOption = [
  { label: "10", value: 10 },
  { label: "20", value: 20 },
  { label: "50", value: 50 },
  { label: "100", value: 100 },
  { label: "200", value: 200 },
];

export const userRoleOptions = [
  { label: "Select Type", value: "" },
  { label: "Researcher", value: "researcher" },
  { label: "Participant", value: "participant" },
];

export const supportFilterValue = (type)=>{
  console.log(type,"type")
  const helpSupport={
    "Website Queries":"contact",
    "Help":"help"
  }[type||"Website Queries"]

  console.log(helpSupport)

  return helpSupport
}